// extracted by mini-css-extract-plugin
module.exports = {"navigationMenu":"styles_navigationMenu__lYgEf","logo":"styles_logo__lRi3y","fadeInOut":"styles_fadeInOut__kq0ig","loader":"styles_loader__BhfnG"};